var scope_0 = require('/Users/viral/mnemonic/yemeni-attacks-on-media/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/24a6390e23b2b1ad129750e16ea2bb3a.js').default;
var scope_1 = require('/Users/viral/mnemonic/yemeni-attacks-on-media/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/924bad8b5896d39fc152a6b54b4a6995.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    